<template>
  <div class="layout">
    <div class="ImportDetails">
      <v-card elevation="0" class="cardImport">
        <!-- Start Details Import -->
        <v-card-title class="pt-7">{{
          $t("ImportDetails.title")
        }}</v-card-title>
        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.id")
              }}</span>
              {{ importSelected.id }}
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.trStart")
              }}</span>
              <span>{{ importSelected.start }}</span>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.dateStart")
              }}</span>
              {{ importSelected.startOfSync }}
            </v-card-text>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-card-text>
              <v-row align="center" class="mx-0">
                <span class="font-weight-medium">{{
                  $t("ImportDetails.trFailed")
                }}</span>
                <br />
                <v-icon :color="importSelected.failed ? 'error' : 'success'"
                  >mdi-cloud-download</v-icon
                >
              </v-row>
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.trEnd")
              }}</span>
              {{ importSelected.end }}
            </v-card-text>
          </v-col>
          <v-col cols="12" sm="4">
            <v-card-text>
              <span class="font-weight-medium">{{
                $t("ImportDetails.trDateEnd")
              }}</span>
              {{ importSelected.endOfSync }}
            </v-card-text>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <span class="font-weight-medium">{{
              $t("ImportDetails.trMessage")
            }}</span>
            <br />
            <pre style="white-space: pre-wrap">
              {{ importSelected.message }}
            </pre>
          </v-col>
        </v-row>
        <!-- End Details Import -->
        <v-card-actions>
          <v-btn @click="goBack">
            <v-icon dark> mdi-arrow-left </v-icon>
            {{ $t("ImportDetails.back") }}
          </v-btn>

          <v-btn small @click="goToList()">
            {{ $t("ImportDetails.list") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>
<script>
import { getSyncByIdHttp } from "@/services/planning/SyncService.js";

export default {
  components: {},
  props: {},

  data() {
    return {
      importSelected: null,
    };
  },
  async mounted() {},
  created() {
    this.getImport();
  },
  methods: {
    getImport() {
      getSyncByIdHttp(this.$route.params.id)
        .then((res) => {
          this.importSelected = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goBack() {
      return this.$router.go(-1);
    },
    goToList() {
      this.$router.push({
        name: "ImportsList",
      });
    },
  },
};
</script>

<style lang="scss">
.layout {
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.import {
  margin: 3rem auto;
  width: 80%;
}

.cardImport {
  padding: 3rem 3rem;
}

.before-state {
  color: #b6b6b6;
  font-style: italic;
}

.right {
  font-size: 0.9rem;
}
</style>
